import base from './base'
import qs from 'qs'

let controller = 'auth'
let action = null

class Auth {
  constructor (vueInst) {
    this.vue = vueInst
  }
  async getCaptcha () {
    action = 'Captcha'
    let reqModel = {
      method: 'GET',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  }

  async sendBindSmsCode (mobile) {
    action = 'SendBindSms'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: {
        mobile: mobile
      }
    }
    return base.request(reqModel)
  }

  async sendVerifySmsCode () {
    action = 'SendVerifySms'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: null
    }
    return base.request(reqModel)
  }

  async sendSmsCode (mobile) {
    action = 'SendSms'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: {
        mobile: mobile
      }
    }
    return base.request(reqModel)
  }

  async loginViaSms (model) {
    action = 'LoginWithSms'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      data: {
        mobile: model.mobile,
        smsCode: model.sms
      }
    }
    return await base.request(reqModel).then((payload) => {
      this.vue.$store.dispatch('setToken', payload)
      return Promise.resolve(payload)
    }).catch(err => {
      return Promise.reject(err)
    })
  }

  async bindCert (model) {
    action = 'BindCert'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: {
        issuer: model.issuer,
        certSn: model.certSn,
        certBase64: model.certBase64
      }
    }
    return base.request(reqModel)
  }

  async bindMobile (mobile, code) {
    action = `BindMobile/${mobile}/${code}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: null
    }
    return base.request(reqModel)
  }

  async changeMobile (mobile, code) {
    action = `ChangeMobile/${mobile}/${code}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: null
    }
    return base.request(reqModel)
  }

  async loginViaCert (model) {
    action = 'LoginWithCert'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      data: {
        rand: model.rand,
        certSn: model.certSn,
        sign: model.sign
      }
    }
    return await base.request(reqModel).then((payload) => {
      this.vue.$store.dispatch('setToken', payload)
      return Promise.resolve(payload)
    }).catch(err => {
      return Promise.reject(err)
    })
  }

  async login (model) {
    action = 'Login'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      data: model
    }
    return await base.request(reqModel).then((payload) => {
      this.vue.$store.dispatch('setToken', payload)
      return Promise.resolve(payload)
    }).catch(err => {
      return Promise.reject(err)
    })
  }
  
  async logout () {
    action = 'Logout'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  }

  async getMyDetail () {
    action = 'MyDetail'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  }

  async listUsers (query, pageIndex = 1, pageSize = 20) {
    let querys = {
      currentPage: pageIndex || query.pageIdex,
      pageSize: pageSize || query.pageSize,
      sort: query.sort,
      ascending: query.ascending
    }
    Object.assign(querys, query)
    querys.enabled = query.enabled !== null ? query.enabled ? true : false : null
    action = 'ListUsers'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: querys
    }
    return base.request(reqModel)
  }

  async listUsersByType (type = 3) {
    action = `ListAvaliableUsersByType/${type}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: null
    }
    return base.request(reqModel)
  }

  async assignRoleToUser (userId, roleId) {
    action = `AssignRoleToUser/${userId}/${roleId}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: null
    }
    return base.request(reqModel)
  }

  async register (request) {
    let model = {
      displayName: request.displayName || null,
      passwordMd5: request.passwordMd5 || null,
      loginName: request.loginName || null,
      enabled: true,
      mobile: request.mobile || null,
      type: 3,
      certCn: null,
      roleId: null
    }
    action = 'Register'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: model
    }
    return base.request(reqModel)
  }

  async registerContractorUser (request) {
    let model = {
      companyName: request.companyName || null,
      businessLicense: request.businessLicense || null,
      contact: request.contact || null,
      contactTel: request.contactTel || null,
      address: request.address || null,
      email: request.email || null,
      legalPersonName: request.legalPersonName || null,
      displayName: request.displayName || null,
      passwordMd5: request.passwordMd5 || null,
      loginName: request.loginName || null,
      enabled: true,
      mobile: request.mobile || null,
      type: 3,
      certCn: null,
      roleId: null
    }
    action = 'RegisterContractor'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: model
    }
    return base.request(reqModel)
  }

  async addUser (request) {
    let model = {
      displayName: request.displayName || null,
      passwordMd5: request.passwordMd5 || null,
      loginName: request.loginName || null,
      enabled: request.enabled || true,
      mobile: request.mobile || null,
      type: request.type || 1,
      certCn: request.certCn || null,
      roleId: request.roleId || null
    }
    action = 'Create'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: model
    }
    return base.request(reqModel)
  }

  async updateUser (request) {
    let model = {
      id: request.id || null,
      displayName: request.displayName || null,
      oldPasswordMd5: request.oldPasswordMd5 || null,
      passwordMd5: request.passwordMd5 || null,
      loginName: request.loginName || null,
      enabled: request.enabled || true,
      mobile: request.mobile || null,
      type: request.type || 1,
      certCn: request.certCn || null,
      roleId: request.roleId || null
    }
    if (!model.id) {
      throw new Error('提交数据不合法!ID为空')
    }
    action = `Update/${model.id}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: model
    }
    return base.request(reqModel)
  }

  async updateUserPassword (request) {
    let model = {
      id: request.id || null,
      oldPasswordMd5: request.oldPasswordMd5 || null,
      passwordMd5: request.passwordMd5 || null,
    }
    if (!model.id) {
      throw new Error('提交数据不合法!ID为空')
    }
    if (!model.oldPasswordMd5) {
      throw new Error('提交数据不合法!原密码为空')
    }
    if (!model.passwordMd5) {
      throw new Error('提交数据不合法!新密码为空')
    }
    action = `UpdateUserPassword/${model.id}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: model
    }
    return base.request(reqModel)
  }


  async resetUserPass (userId) {
    if (!userId) {
      throw new Error('UserID为空')
    }
    action = `ResetUserPassword/${userId}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  }

  async enableUser (userId) {
    if (!userId) {
      throw new Error('UserID为空')
    }
    action = `EnableUser/${userId}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  }

  async disableUser (userId) {
    if (!userId) {
      throw new Error('UserID为空')
    }
    action = `DisableUser/${userId}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  }

  async deleteUser (userId) {
    if (!userId) {
      throw new Error('UserID为空')
    }
    action = `Delete/${userId}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  }

  async getUserSealImage () {
    action = 'GetSealImage'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  }

  async setUserSealImage (sealImage) {
    action = 'SetSealImage'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: qs.stringify({
        sealImage
      }),
      options: {
        headers: {
          // 'Content-Type': 'application/json'
        }
      }
    }
    return base.requestRaw(reqModel)
  }
}

export default Auth